import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { PlatformExportSettings } from './PlatformExportSettings';

interface Props {
  platform: SocialPlatform;
  fieldPrefix?: string;
}

export function FragmentSocialExportSettings({ platform, fieldPrefix }: Props) {
  const fieldName = `${fieldPrefix || ''}.enabled`.replace(/^\./, '') as any;
  const enabled = useWatch({ name: fieldName });

  if (!enabled) {
    return <div />;
  }

  return (
    <Box mt={1} mb={2}>
      <PlatformExportSettings platform={platform} fieldPrefix={fieldPrefix} />
    </Box>
  );
}
